/**
 * jQuery Script used with Bootstrap and popper.js
 * 
 */

{
    /* tooltip */
    $('[data-toggle="tooltip"]').tooltip({
        placement: 'top',
    })

    /* scroll */
    $('#gotop').on('click', function(e){
        e.preventDefault()
        $('html,body').animate({scrollTop:$('body').offset().top})
    })

}


// WEBPACK FOOTER //
// ./src/jquery-things.js